<template>
    <div style="margin:0 10px">
        <router-view></router-view>
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center j-sb">
                <div class="d-flex a-center">
                    <div style="width:200px;margin-right:10px;">
                        <el-input type="text" v-model="query.keyword" placeholder="请输入关键词" class="search-input"></el-input>  
                    </div>
                    <el-button class="search-button" @click="init"></el-button>
                    <el-button class="add-button" @click="$router.push({name:'agents_knowledge_add'})"></el-button>    
                </div>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                >
                    <el-table-column prop="id" label="ID" align="center"></el-table-column>
                    <el-table-column prop="agentName" label="智能体名称" align="center"></el-table-column>
                    <el-table-column prop="knowledgeText" label="知识库内容" align="center"></el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'agents_knowledge_add',query:{id:scope.row.id}})" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                    title="是否确定删除？"
                                    confirm-button-text="确认删除"
                                    @confirm="handleDel(scope.row)"
                                >
                                    <el-button style="margin-left: 10px;" slot="reference" type="text" class="delete-action">删除</el-button>
                                </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- page -->
                <div style="margin-top:20px;text-align:center">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :page-sizes="[20,30,50,100]"
                        :total="total"
                        :page-size="query.limit"
                        @size-change="onSize"
                        @current-change="onCurrPage"
                        @prev-click="onCurrPage"
                        @next-click="onCurrPage"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { page,del } from '../../../request/api/agents_knowledge';
export default {
    data(){
        return {
            tableData: [],
            query:{page:1,size:10},
            total:0 , //列表总数
            loading:false,
            isEdit:false ,//编辑状态
        }
    },
    watch:{
        $route(val ,old){
            //返回刷新
            if(val.name=='agents_knowledge') {
                this.init()
            }
        }
    },
    created(){
        this.init()
    },

    methods:{
        init(){
            this.loading=true
            page(this.query).then(res=>{
                this.tableData = res.data.list
                this.total = res.data.total
                this.loading=false
            })
        },
        handleDel(row){
            del({id:row.id}).then(res=>{
                if(res.code!=0) return this.$notify({title: '失败',message:res.msg,type: 'error'});
                this.init()
                this.$notify({title: '成功',message: "SUCCESS",type: 'success'});
            })
        },

        //每页条数
        onSize(val){
            this.query.size=val
            this.init()
        },
        onCurrPage(val){
            this.query.page = val
            this.init()
        }

    }
}
</script>


<style scoped lang="less">


</style>

